<p>in-details-nfe-modal works!</p>
